module.exports = __webpack_public_path__ + "static/media/library.bf746b62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/elements/screen-images/music/library.jpg
// module id = 700
// module chunks = 0